import { makeActionCreator } from '../../redux-util/general-helpers';
import { areToolsCollapsed, isBookCompleteShowing } from './kiddie-selectors';
import { nextPage, prevPage } from '../../redux-jigsaw/jigsaw-action';
import { hasNextPage } from '../../redux-jigsaw/page-context-selectors';

export const toggleReadAloud = makeActionCreator('ui.kiddie.toggleReadAloud');
export const toggleBookCompletePage = makeActionCreator(
  'ui.kiddie.toggleBookCompletePage'
);

export const toggleToolsCollapsed = makeActionCreator(
  'ui.kiddie.toggleToolsCollapsed'
);

export function prevPageKiddie() {
  return function(dispatch, getState) {
    if (isBookCompleteShowing(getState())) {
      dispatch(toggleBookCompletePage());
    } else {
      dispatch(prevPage());
    }
  };
}

export function nextPageKiddie() {
  return function(dispatch, getState) {
    if (!hasNextPage(getState())) {
      dispatch(toggleBookCompletePage());
    } else {
      dispatch(nextPage());
    }
  };
}

export function hideBookCompletePage() {
  return function(dispatch, getState) {
    if (isBookCompleteShowing(getState())) {
      dispatch(toggleBookCompletePage());
    }
  };
}

export function collapseTools() {
  return function(dispatch, getState) {
    if (!areToolsCollapsed(getState())) {
      dispatch(toggleToolsCollapsed());
    }
  };
}
